'use strict';
var processInclude = require('base/util');
$(document).ready(function () {
    processInclude(require('./search/search'));
    processInclude(require('base/product/quickView'));
    // PMangalore - Wishlist
    // Is there a better way to selectively reference certain files? This could cause conflicts
    processInclude(require('./product/wishlistHeart'));
});
